<template>
  <div class="NavBarApps pt-4">
    <p class="px-4">
      <strong>Apps</strong>
    </p>
    <a :href="monitoringUrl" target="_blank" rel="noopener" class="d-flex align-items-center px-4">
      <i class="far fa-fw fa-chart-line mr-3" />
      <span>Monitoring</span>
    </a>

    <!-- Hidden for now -->
    <!-- <a href="https://workflow.evtools.nl" target="_blank" rel="noopener" class="d-flex align-items-center px-4">
      <i class="far fa-fw fa-diagram-project mr-3" />
      <span>Workflow</span>
    </a> -->
  </div>
</template>

<script>
import { EventBus } from '@/services/eventbus'

export default {
  name: 'NavBarApps',
  computed: {
    monitoringUrl() {
      const audience = process.env.VUE_APP_AUTH_AUDIENCE || ''
      const isDev = audience.includes('dev') || window.location.hostname.startsWith('dev.')
      return isDev
        ? 'https://monitoring-dev.netlify.app'
        : 'https://monitoring.evtools.nl'
    },
  },
  created() {
    EventBus.$on('overlay-click', this.close)
  },
  beforeDestroy() {
    EventBus.$off('overlay-click', this.close)
  },
  methods: {
    close() {
      EventBus.$emit('overlay-hide')
    },
  },
}
</script>

<style lang="scss">
.NavBarApps {
  background: white;
  z-index: 999999;
  opacity: 0.999;
  min-width: 220px;

  p {
    font-size: 1.15rem;
  }

  a {
    font-size: 1.15rem;
    margin-bottom: 1rem;
    color: var(--primary-text);

    &:hover {
      text-decoration: none;
      color: #b04300;
      cursor: pointer;
    }
  }
}
</style>
